import React from 'react'
import { Stack } from '@mantine/core'
import ItemWrapper from '../../../components/ItemWrapper'
import LabeledTitle from '../../../components/LabeledTitle'
import ExpandableListWrapper from '../../../components/ExpandableListWrapper'
import CompanyCard from './CompanyCard'
import { CompanyItem } from './types'

interface CompanyListProps {
  companies: CompanyItem[]
}

const CompanyList: React.FC<CompanyListProps> = ({ companies }) => {
  return (
    <ItemWrapper>
      <LabeledTitle title="关联企业详情" />
      <Stack gap="md">
        <ExpandableListWrapper isEmpty={companies.length === 0}>
          {companies.map((company, index) => (
            <CompanyCard key={index} company={company} />
          ))}
        </ExpandableListWrapper>
      </Stack>
    </ItemWrapper>
  )
}

export default CompanyList
